import { K, mono } from '../lib/theme'

const WD = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

/** The 168-hour week: cyan where the equity market is open, amber where the
 *  tokens keep trading without it. This is the thesis as a picture, so the
 *  arithmetic behind it stays visible in the legend. */
export function WeekGrid({ now, closedHours, openHours }: { now: Date; closedHours: number; openHours: number }) {
  const p = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', hour12: false, weekday: 'short', hour: '2-digit',
  }).formatToParts(now)
  const wd = p.find((x) => x.type === 'weekday')?.value ?? 'Mon'
  const hrRaw = Number(p.find((x) => x.type === 'hour')?.value ?? 0)
  const nowRow = WD.indexOf(wd)
  const nowHour = hrRaw === 24 ? 0 : hrRaw

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, fontFamily: mono, fontSize: 11, color: K.dim, marginBottom: 8, letterSpacing: '.04em' }}>
        <span>ONE WEEK · HOUR OF DAY, ET</span>
        <span style={{ color: K.txt }}>{wd} {String(nowHour).padStart(2, '0')}:00</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {WD.map((d, row) => (
          <div key={d} style={{ display: 'flex', gap: 2, alignItems: 'stretch' }}>
            <div style={{ width: 32, flex: 'none', fontFamily: mono, fontSize: 11, color: K.dim, display: 'flex', alignItems: 'center' }}>{d}</div>
            {Array.from({ length: 24 }, (_, h) => {
              const weekday = row < 5
              // 09:30–16:00 ET. The 09:00 cell is half a session hour, so it is
              // drawn dimmer rather than claimed as fully open.
              const full = weekday && h >= 10 && h < 16
              const half = weekday && h === 9
              const isNow = row === nowRow && h === nowHour
              const bg = full ? K.cy : half ? 'rgba(77,225,255,.5)' : 'rgba(255,184,77,.35)'
              return (
                <div key={h} title={`${d} ${String(h).padStart(2, '0')}:00 ET · ${full || half ? 'market open' : 'closed, tokens still trading'}`}
                  style={{ flex: '1 1 0', minWidth: 0, height: 13, background: bg, outline: isNow ? `2px solid ${K.txt}` : 'none', outlineOffset: 1 }} />
              )
            })}
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 2, margin: '6px 0 0 34px', fontFamily: mono, fontSize: 10, color: K.faint }}>
        <span style={{ flex: 1 }}>00</span><span style={{ flex: 1 }}>06</span><span style={{ flex: 1 }}>12</span>
        <span style={{ flex: 1, textAlign: 'right' }}>18 → 24</span>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 18px', marginTop: 12, fontSize: 12, color: K.mut }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}><span style={{ width: 10, height: 10, background: K.cy }} />market open · <span style={{ fontFamily: mono }}>{openHours} h</span></span>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}><span style={{ width: 10, height: 10, background: 'rgba(255,184,77,.35)' }} />closed, tokens still trading · <span style={{ fontFamily: mono }}>{closedHours} h</span></span>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}><span style={{ width: 10, height: 10, outline: `2px solid ${K.txt}`, outlineOffset: -1 }} />now</span>
      </div>
    </div>
  )
}
